import { Get } from "../../../api/apiHelper";
import { ServiceProvider } from "../../../interfaces/ServiceProvidersInterface";

const rootSp = "/api/resourcecentreserviceproviders";

const getServiceProviders = async (rcId: number): Promise<ServiceProvider[]> => {
  const response = await Get(`${rootSp}?resourceCentreId=${rcId}`);
  return response.data as ServiceProvider[];
};

export default getServiceProviders;
